<p-panel header="{{ 'fs.res.common.externalPerson.Person' | hisUi }}">

		<his-plam [required]="true" label="{{ 'psv.Person.surname' | hisUi }}">
			<input #content hisDdKey="cs.psv.Person.surname" [(ngModel)]="externalPerson.surname" class="inputWidth100">
		</his-plam>

		<his-plam [required]="true" label="{{ 'psv.Person.firstname' | hisUi }}">
			<input #content hisDdKey="cs.psv.Person.firstname" [(ngModel)]="externalPerson.firstname" class="inputWidth100">
		</his-plam>

		<his-plam [required]="true" label="{{ 'psv.Person.genderId' | hisUi }}">
			<p-autoComplete #content hisDdKey="cs.psv.Person.gender" 
				[(ngModel)]="externalPerson.gender" hisEagerDataSource="gender">
			</p-autoComplete>
		</his-plam>

</p-panel>	
